<form
  [formGroup]="form"
  (ngSubmit)="changed.next()">
  <div
    class="assign-number-edit"
    *ngIf="editMode">
    <mat-select
      formControlName="msisdnId"
      class="p-y-1"
      (selectionChange)="onSelectChange($event, selectedMsisdn)"
      [placeholder]="'MAPPING.SELECT_PLACEHOLDER' | translate">
      <mat-select-trigger>
        <cc-msisdn
          *ngIf="selectedMsisdn"
          [msisdn]="selectedMsisdn"
          [small]="true"></cc-msisdn>
      </mat-select-trigger>
      <mat-option
        class="cc-msisdn"
        *ngFor="let msisdn of msisdns"
        [value]="msisdn.id">
        <cc-msisdn [msisdn]="msisdn"></cc-msisdn>
      </mat-option>
    </mat-select>
    <cc-input-errors [form]="form"
                     inputName="msisdnId"
                     [errors]="[{'required': 'MAPPING.ERRORS.SELECT'}]"></cc-input-errors>
    <button
      mat-raised-button
      [disabled]="form.invalid"
      color="primary-full">
      <span translate>{{isAddPhoneNumber() ? 'SAVE' : 'ADD'}}</span>
    </button>
  </div>

  <div
    class="assign-number"
    *ngIf="!editMode">
    <div class="logo">
      <cc-msisdn
        [msisdn]="{isoCountry: form.get('callerIdCountryCode').value, label: form.get('callerIdLabel').value}"
        [small]="true"></cc-msisdn>
    </div>
    <div class="edit-tool grey-text">
      <i
        class="material-icons h-1"
        (click)="changeEditMode.next()">edit</i>
      <i
        class="material-icons h-1"
        (click)="delete.next()">delete</i>
    </div>
  </div>
</form>
